export const CustomerRouteSegments = {
  INFO: "info",
  ANALYSIS: "analysis",
  GROUP: "group",
  MEETING_PREP: "meeting-prep",
  MEETING_PREP_PROFILE: "meeting-prep/profile",
  TODOS: "todos",
  ORDERS: "orders",
  ORDER_DETAILS: "orders/:orderId",
  OFFERS: "offers",
  OFFER_DETAILS: "offers/:offerId",
} as const;

const CUSTOMER_DETAILS = "/customer-details/:id";

const Routes = {
  UNAUTHORIZED: "/unauthorized",
  HOME: "/home",
  OPEN_RECAPS: "/open-recaps",
  CUSTOMER_RECAPS: "/customer-recaps/:id",
  MANAGEMENT: "/management",
  WELCOME: "/welcome",
  PRIORITISE_MEETINGS: "/prioritise-meetings",
  PLANNED_MEETINGS: "/planned-meetings",
  CUSTOMERS: "/customers",
  TODOS_OVERVIEW: "/todos",
  CALENDAR: "/calendar",
  USER_PROFILE: "/profile",
  CUSTOMER_DETAILS,
  CUSTOMER_INFO: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.INFO}`,
  CUSTOMER_ANALYSIS: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.ANALYSIS}`,
  CUSTOMER_GROUP: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.GROUP}`,
  MEETING_PREP: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.MEETING_PREP}`,
  MEETING_PREP_PROFILE: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.MEETING_PREP_PROFILE}`,
  CUSTOMER_TODOS: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.TODOS}`,
  CUSTOMER_ORDERS: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.ORDERS}`,
  CUSTOMER_ORDER_DETAILS: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.ORDER_DETAILS}`,
  CUSTOMER_OFFERS: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.OFFERS}`,
  CUSTOMER_OFFER_DETAILS: `${CUSTOMER_DETAILS}/${CustomerRouteSegments.OFFER_DETAILS}`,
  CHAT: "/chat",
  ANALYSIS: "/analysis",
} as const;

export type Routes = (typeof Routes)[keyof typeof Routes];

export default Routes;
